class Simboleum {

    constructor(

    ) {
        this.rH = this.rdH;
    }

    

    genH(id) {
        const map = new Map([
            [0, '△'],
            [1, '◩'],
            [2, '◲'],
            [3, '◙'],
            [4, '◍'],
            [5, '▨'],
            [6, '▣'],
            [7, '▧'],
            [8, '►'],
            [9, '◈']
        ]);
        const genSE = (id) => {
            const mirror = id.toString().split('').reverse();
            return {
                s: `${mirror[1]}${mirror[3]}`,
                e: `${mirror[0]}${mirror[2]}`
            };
        }

        const sE = genSE(id);

        const hashNums = `${sE.s}${id}${sE.e}`;
        
        let hash = hashNums.split('').reduce((string, char) => {
            const currChar = map.get(parseInt(char, 10));
            return `${string}${currChar}`
        }, '');
        return hash;
    }

    get rdH() {
        const randomId = Math.floor(1000 + Math.random() * 9000);
        return this.genH(randomId);
    }

    set rHS(id) {
        this.rH = this.genH(id);
    }

    get rHS() {
        return this.rH
    }
};

export const simbPlug = {
    install: (Vue, options) => {
        const instance = new Simboleum();
        Vue.prototype.$simbIHC = instance;
    }
}